import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '@src/environments/environment';

@Injectable()
export class CidInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!req.url.includes(`${environment.apiHost}/v1`)) {
      return next.handle(req);
    }

    const cid: string | null = sessionStorage.getItem('cid');
    if (!cid) {
      return next.handle(req);
    }

    return next.handle(req.clone({ headers: req.headers.set('cid', cid) }));
  }
}
